import gql from 'graphql-tag';

export const CHANGE_EMAIL = gql`
  mutation changeEmailAddress($emailChange: ChangeEmailAddressInput!) {
    changeEmailAddress(input: $emailChange) {
      ... on ChangeEmailAddressSuccess {
        ref
      }
      ... on ChangeEmailAddressFailure {
        error {
          __typename
          message
          code
          reason
          ... on AccountValidationError {
            details {
              message
              code
              path {
                field
                path
              }
              reason
            }
          }
        }
      }
    }
  }
`;
